import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { User, Loader2 } from 'lucide-react';
import { api } from '@/lib/api-client';
import { useConfirm } from '@/contexts/ConfirmContext';
/** Seuls les membres actifs de la ville sont proposés (le serveur le vérifie aussi). */
export function AssigneeSelect({ reportId, tenantId, currentAssigneeId }) {
    const qc = useQueryClient();
    const confirm = useConfirm();
    const { data: people = [], isLoading } = useQuery({
        queryKey: ['assignable', tenantId],
        queryFn: () => api.users.assignable(tenantId),
        staleTime: 60_000,
    });
    const assign = useMutation({
        mutationFn: (userId) => api.reports.update(reportId, { assignedToUserId: userId }),
        onSuccess: () => {
            toast.success('Assignation mise à jour');
            qc.invalidateQueries({ queryKey: ['report', reportId] });
            qc.invalidateQueries({ queryKey: ['reports'] });
        },
        onError: (err) => toast.error(err.message),
    });
    if (isLoading) {
        return (_jsxs("div", { className: "flex items-center gap-2 text-xs text-muted-foreground", children: [_jsx(Loader2, { className: "size-3 animate-spin" }), "Chargement de l'\u00E9quipe\u2026"] }));
    }
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(User, { className: "size-4 text-muted-foreground" }), _jsxs("select", { value: currentAssigneeId ?? '', onChange: async (e) => {
                    const userId = e.target.value || null;
                    const person = people.find((p) => p.id === userId);
                    const ok = await confirm(person
                        ? { title: `Assigner ce signalement à ${person.firstName} ${person.lastName} ?` }
                        : { title: "Retirer l'assignation de ce signalement ?", message: 'Il ne sera plus attribué à personne.' });
                    if (ok)
                        assign.mutate(userId);
                }, disabled: assign.isPending, className: "flex-1 rounded-md border border-input bg-background px-2 py-1 text-xs", "aria-label": "Assigner \u00E0", children: [_jsx("option", { value: "", children: "Non assign\u00E9" }), people.map((p) => (_jsxs("option", { value: p.id, children: [p.firstName, " ", p.lastName, ", ", p.role === 'ADMIN' ? 'Admin' : p.role === 'FIELD_AGENT' ? 'Agent terrain' : `Gestionnaire${p.categoryName ? ` (${p.categoryName})` : ''}`] }, p.id)))] })] }));
}
//# sourceMappingURL=AssigneeSelect.js.map